/** Minimum characters for shared narrative fields using `app-notes-textarea-field`. */
export const SHARED_NOTES_TEXTAREA_MIN_LENGTH = 60
